import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { Props } from './EditBackgroundButton';
import { DeviationBackgroundStoreSlice } from '../../../DeviationBackground/redux/types';
import {
  getCurrentBackgroundId,
  getIsBackgroundsPopupOpen,
} from '../../../DeviationBackground/redux/selectors';
import {
  initializeBackgrounds,
  showBackgroundPicker,
} from '../../../DeviationBackground/redux/actions';

export type StateProps = Pick<Props, 'currentBackgroundId' | 'isBackgroundsPopupOpen'>;
export type DispatchProps = Pick<Props, 'showBackgroundPicker' | 'onInitialize'>;
export type OwnProps = Omit<Props, keyof (DispatchProps & StateProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, DeviationBackgroundStoreSlice> = (
  state,
  { deviation }
) => {
  return {
    currentBackgroundId: getCurrentBackgroundId(state, deviation),
    isBackgroundsPopupOpen: getIsBackgroundsPopupOpen(state),
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  onInitialize: initializeBackgrounds,
  showBackgroundPicker,
};

export default connect(mapStateToProps, mapDispatchToProps);
